module.exports = __webpack_public_path__ + "img/polygon.2b98a4f0.jpg";